import React from 'react'

import { Button, Link, Typography } from '@vp/swan'
import { useSizeChartContext } from '../../contexts/SizeChartContext'
import { useInventory } from '../../../root/contexts/InventoryContext'
import { useLocalizations } from '@vp/ubik-localizations-provider'

const SizeChartFlyoutLink: React.FC = () => {
  const { t } = useLocalizations()
  const { isSizeChartLoaded, handleSizeChartClick } = useSizeChartContext()
  const inventoryState = useInventory()
  // Ensure the the size chart link renders at the same time as other components (after inventory loads)
  const isPageLoading = !inventoryState.isInventoryStateInitialized

  return (
    <>
      {isSizeChartLoaded && !isPageLoading && (
        <Typography noWrap>
          <Link
            render={(p) => (
              <Button skin="link" className={p.className} onClick={handleSizeChartClick} data-testid="size-chart-link">
                {p.children}
              </Button>
            )}
          >
            {t('size-chart.see-sizechart')}
          </Link>
        </Typography>
      )}
    </>
  )
}

export default SizeChartFlyoutLink
